import React from "react";

import PageNotFoundSvg from "../../assets/icons/page-not-found.svg";

import "./styles.scss";

const PageNotFound = () => (
  <img src={PageNotFoundSvg} alt="not found" className="page-not-found" />
);

export default PageNotFound;
